var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#import-export_svg__clip0_61530_7407)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 18v3H3v-3H1.5v3l.006-.004A1.498 1.498 0 003 22.5h18a1.5 1.5 0 001.5-1.5v-3H21zM20.7 10.95l-2.7 2.7V3h-1.5v10.65l-2.7-2.7L12.75 12l4.5 4.5 4.5-4.5-1.05-1.05zM6.75 3l-4.5 4.5L3.3 8.55 6 5.85V16.5h1.5V5.85l2.7 2.7 1.05-1.05L6.75 3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "import-export_svg__clip0_61530_7407"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgImportExport;